import { withStyles, Button, CircularProgress } from '@material-ui/core';
const styles = (theme) => ({
  dialogActionStyle: {
    display: 'flex',
    alignSelf: 'flex-end',
    marginTop: 4
  },
  dialogButtonStyle: {
    fontSize: theme.textFontSize,
    textTransform: 'none',
    borderRadius: '2px',
    float: 'right',
    '&$disabledButton': {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8
    }
  },
  disabledButton: {},
  circularProgress: {
    color: theme.palette.primary.main
  }
});

const Action = (props) => {
  const { isDisabled, isUpdateInProgress, onClick, classes, onClose } = props;

  return (
    <div className={classes.dialogActionStyle}>
      <Button
        id="cancel"
        onClick={onClose}
        color="secondary"
        size="medium"
        classes={{
          root: classes.dialogButtonStyle,
          disabled: classes.disabledButton
        }}>
        Cancel
      </Button>
      <Button
        id="update"
        disabled={isDisabled}
        onClick={onClick}
        color="primary"
        classes={{
          root: classes.dialogButtonStyle,
          disabled: classes.disabledButton
        }}>
        {isUpdateInProgress ? (
          <CircularProgress size={16} classes={{ root: classes.circularProgress }} />
        ) : (
          'Add'
        )}
      </Button>
    </div>
  );
};

export default withStyles(styles)(Action);
